/* eslint-disable @typescript-eslint/naming-convention */
import type { MatchDataBlock } from '@ps/web-martech-cms-types/ContentArea';
import React from 'react';

import { TXTCLI_Preview, TXTCLI_Report_3 } from './CMSMatch.messages.json';
import MatchDetails from './components/MatchDetails/MatchDetails';
import MatchGrid from './components/MatchGrid/MatchGrid';

const CMSMatch: React.FC<MatchDataBlock> = ({ match_data: { type, reference } }) => {
  const MatchData = type === 'Grid' ? MatchGrid : MatchDetails;

  return (
    <MatchData
      dataRef={reference}
      previewTranslation={TXTCLI_Preview}
      reportTranslation={TXTCLI_Report_3}
    />
  );
};

export default CMSMatch;
